export const products = [
  {
    id: 1,
    name: "HydraBloom Moisturizer",
    price: 185000,
    image: "https://t3.ftcdn.net/jpg/12/17/50/48/360_F_1217504813_ieMnnCQSH2hZmw2VoObcJ1R67A5NmN0G.jpg",
    category: "Moisturizer",
    description: "Deeply hydrates and restores moisture with hyaluronic acid and aloe vera.",
  },
  {
    id: 2,
    name: "ClearGlow Gel Cleanser",
    price: 125000,
    image: "https://shopigo.com/cdn/shop/files/RefreshingCleanserGel_1.webp?v=1731678789&width=600",
    category: "Cleanser",
    description: "Oil-control gel cleanser with salicylic acid for clearer skin.",
  },
  {
    id: 3,
    name: "SootheCalm Serum",
    price: 210000,
    image: "https://media.istockphoto.com/id/1329478255/photo/bottle-of-cosmetic-essential-oil-and-green-leaf-serum-oil-is-dripping-from-dropper-close-up.jpg?s=612x612&w=0&k=20&c=wxKrOiCzVNs5-0PqPZoW3ABIN-bOydmY28CxfLXpp2k=",
    category: "Serum",
    description: "Calming serum with niacinamide and tea tree for acne-prone skin.",
  },
  {
    id: 4,
    name: "Daily Radiance Sunscreen SPF 50",
    price: 160000,
    image: "https://images.pexels.com/photos/9496427/pexels-photo-9496427.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    category: "Sunscreen",
    description: "Broad-spectrum SPF 50 with antioxidant-rich formula for all-day protection.",
  },
  {
    id: 5,
    name: "ReviveNight Renewal Cream",
    price: 225000,
    image: "https://www.cosmetify.com/images/products/nipfab-ceramide-fix-overnight-cream-12-50ml.jpg",
    category: "Moisturizer",
    description: "Peptide-rich night cream for intense hydration and overnight repair.",
  },
  {
    id: 6,
    name: "Balancing Toner Mist",
    price: 95000,
    image: "https://yellowbeauty.com/cdn/shop/products/IMG_0326-min_1080x.png?v=1677989797",
    category: "Toner",
    description: "Refreshing mist with witch hazel and green tea to balance skin.",
  },
  {
    id: 7,
    name: "Acne Rescue Spot Treatment",
    price: 110000,
    image: "https://imageskincare.com/cdn/shop/products/CLEAR-CELL-CLARIFYING-ACNE-SPOT-TREATMENT-PDP-R04.jpg?v=1679327076&width=1800",
    category: "Treatment",
    description: "Benzoyl peroxide spot treatment to quickly reduce blemishes.",
  },
  {
    id: 8,
    name: "BotaniClean Gentle Cleanser",
    price: 135000,
    image: "https://images.pexels.com/photos/11179690/pexels-photo-11179690.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    category: "Cleanser",
    description: "Botanical cleanser for daily use, gentle on sensitive skin.",
  },
  {
    id: 9,
    name: "GlowTonic Exfoliating Pads",
    price: 145000,
    image: "https://artofskincare.com/cdn/shop/files/hevatox-phaaha-exfoliating-firming-pads-100516.jpg?v=1740590913",
    category: "Treatment",
    description: "Pre-soaked glycolic acid pads to brighten and smooth complexion.",
  },
  {
    id: 10,
    name: "Hydrate & Protect Lip Balm",
    price: 75000,
    image: "https://media.istockphoto.com/id/1446480811/photo/colorful-lip-balms-in-round-tin-cases-with-shadow-overlay-mockup-design.jpg?s=612x612&w=0&k=20&c=18EXL6briC2oPEdCflCHgKJ4tmHlzBweprqoeOY1MXc=",
    category: "Lip Care",
    description: "SPF-infused lip balm with shea butter and jojoba oil.",
  },
  {
    id: 11,
    name: "Nourish+ Eye Cream",
    price: 170000,
    image: "https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/22971800/2023/9/20/2d564b7a-0bcc-4753-992c-a472fc9f065a1695198166939DOTKEYVitaminCESuperBrightEyeCreamSPF30-20ml1.jpg",
    category: "Eye Care",
    description: "Brightens dark circles and smoothens under-eye texture.",
  },
  {
    id: 12,
    name: "Cleansing Balm Luxe",
    price: 195000,
    image: "https://media.istockphoto.com/id/1140934860/photo/reusable-handmade-makeup-remover-pads-and-natural-makeup-remover-balm.jpg?s=612x612&w=0&k=20&c=r4a5HImrejGIkIVR8IH7N8ekFbRNXq6agGSQKZst9iA=",
    category: "Cleanser",
    description: "Melts away makeup and impurities with nourishing oils.",
  },
];


export const articles = [
  {
    id: 1,
    title: "How to Build a Skincare Routine for Your Skin Type",
    excerpt:
      "Not sure where to start? Learn how to personalise your morning and evening rituals based on what your skin really needs.",
    content: "Creating a skincare routine that works for you starts with understanding your skin type...",
    image: "https://images.unsplash.com/photo-1609357912334-e96886c0212b?q=80&w=1528&auto=format&fit=crop",
    date: "2025-04-05",
    author: "Dr. Elina Rahayu",
    authorImage: "https://img.freepik.com/free-photo/asian-female-doctor-physician-medical-uniform-with-stethoscope-cross-arms-chest-smiling-looking-like-professional-white-background_1258-83205.jpg?t=st=1745419039~exp=1745422639~hmac=35099f241945bc447b946c14c9759bc77b423f945c4aa1be43cf074e320e7db6&w=996",
    readTime: "6 min read",
    featured: true,
  },
  {
    id: 2,
    title: "Ingredient Spotlight: Why Your Skin Loves Niacinamide",
    excerpt:
      "Gentle yet powerful, niacinamide is the multitasking hero ingredient you’ll want in every step of your routine.",
    content: "Niacinamide, also known as Vitamin B3, is beloved for its soothing and brightening benefits...",
    image: "https://images.unsplash.com/photo-1703335093128-2989445b88fa?q=80&w=1527&auto=format&fit=crop",
    date: "2025-04-10",
    author: "Sophie Kim",
    authorImage: "https://img.freepik.com/free-photo/lifestyle-beauty-fashion-people-emotions-concept-cheerful-cute-shy-asian-girl-cross-arms-chest-modest-pose-looking-away-as-laughing-smiling-silly-stand-white-background_1258-59330.jpg?t=st=1745419271~exp=1745422871~hmac=b8f97ecdbdbb5a2be00afd2295f02f1efddf9e62d3be7040c3d09ad6b5e640c7&w=996",
    readTime: "5 min read",
    featured: false,
  },
  {
    id: 3,
    title: "Eco-Conscious Beauty: What Makes Skincare Truly Sustainable?",
    excerpt:
      "From packaging to sourcing, here’s how to spot (and support) skincare brands that care for both your skin and the planet.",
    content: "Sustainability in skincare isn't just a buzzword—it’s a commitment to cleaner formulations, fair sourcing, and earth-friendly packaging...",
    image: "https://images.unsplash.com/photo-1610551064520-1ee810f1ba40?q=80&w=1481&auto=format&fit=crop",
    date: "2025-04-15",
    author: "Nadya Tan",
    authorImage: "https://img.freepik.com/free-photo/asia-cute-girl-feel-happy-with-positive-expression-joyful-surprise-laugh-dressed-casual-cloth_74952-4289.jpg?t=st=1745419319~exp=1745422919~hmac=67e34f08b562adee11da0a322ec54a8adc19cad9b7ce162d017f698b61f88f56&w=900",
    readTime: "7 min read",
    featured: false,
  },
  {
    id: 4,
    title: "Understanding the Skin Barrier: Your First Line of Defense",
    excerpt:
      "A healthy skin barrier is the key to radiant, resilient skin. Here's how to protect it.",
    content: "Think of your skin barrier as your skin’s security guard, keeping moisture in and irritants out...",
    image: "https://img.freepik.com/free-photo/cosmetologist-doing-face-treatment-applying-face-mask_1303-28042.jpg?t=st=1745334322~exp=1745337922~hmac=add86c68e2da55b4708b7d28e36a1ce601a1bb94c40d422a143da0ced1c98ee8&w=996",
    date: "2025-03-28",
    author: "Dr. Amanda Surya",
    authorImage: "https://img.freepik.com/free-photo/content-young-female-doctor-posing-camera_1262-18213.jpg?t=st=1745419366~exp=1745422966~hmac=ad940027b8ba38d7f5309074b6f357a0dae6134bc775a392fc021943229f0ad6&w=996",
    readTime: "6 min read",
    featured: false,
  },
  {
    id: 5,
    title: "Morning vs. Evening Skincare: What’s the Difference?",
    excerpt:
      "Your skin’s needs change throughout the day—your routine should too. Here’s why.",
    content: "In the morning, your skin needs protection; at night, it needs repair...",
    image: "https://img.freepik.com/free-photo/front-view-woman-using-serum_23-2150467022.jpg?t=st=1745334386~exp=1745337986~hmac=c161c8c092f7abb372dc3b702aea4e44967a674faaad06b6ea78888c76751cd3&w=900",
    date: "2025-03-22",
    author: "Tasha Ellora",
    authorImage: "https://img.freepik.com/free-photo/beauty-body-positive-emotions-concept-enthusiastic-cute-vietnamese-woman-trendy-office-blouse-cross-hands-chest-smiling-laughing-talking-with-friends-white-wall_176420-35619.jpg?t=st=1745419414~exp=1745423014~hmac=643c4f14d74a044bd19c8277300d22efffda8727b83b5c87924ddcb8c25240c2&w=996",
    readTime: "4 min read",
    featured: false,
  },
  {
    id: 6,
    title: "The Power of Layering: How to Apply Your Skincare Products",
    excerpt:
      "Applying your skincare in the right order can dramatically improve results.",
    content: "The golden rule is to go from thinnest to thickest. Start with toner, then serum, and finally moisturizer...",
    image: "https://img.freepik.com/premium-photo/beauty-portrait-face-cream-by-diverse-women-studio-wellness-grooming-brown-background-friends-skincare-skin-lotion-girl-group-with-different-facial-product-isolated_590464-154164.jpg?w=900",
    date: "2025-03-12",
    author: "Rani Purnama",
    authorImage: "https://img.freepik.com/free-photo/beautiful-young-woman-smiling-camera_74855-2090.jpg?t=st=1745419460~exp=1745423060~hmac=54944f7d00cdbcb7f89d24f3c3efe5357662c628dffd928c5a4d0491a5d7abd1&w=996",
    readTime: "5 min read",
    featured: false,
  },
  {
    id: 7,
    title: "Is Double Cleansing Right for You?",
    excerpt:
      "Double cleansing is more than just a K-beauty trend—it's a skincare staple for some.",
    content: "The first cleanse removes makeup and sunscreen; the second removes dirt and impurities...",
    image: "https://img.freepik.com/free-photo/top-view-bath-concept-accessories_23-2148419370.jpg?t=st=1745334679~exp=1745338279~hmac=b197ed73cfd92278c078cecc4707d947a1ad2da4e01c13b238a8de5d5ea41831&w=996",
    date: "2025-03-05",
    author: "Karen Mitsuko",
    authorImage: "https://img.freepik.com/free-photo/smiley-woman-walking-park_23-2148956890.jpg?t=st=1745419495~exp=1745423095~hmac=3eb6318319b07a14320aafc253e22af21e0f11f19d35d37b3bee67e3f2704e37&w=740",
    readTime: "5 min read",
    featured: false,
  },
];
